<template>
  <div></div>
</template>

<script>
import SvgCopy from './svg/SvgCopy';
export default {
  name: 'Copy',
  components: {
    SvgCopy,
  },
  props: ['text'],
  methods: {
    copyText: function () {
      let dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = this.text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      this.$notify({
        type: 'success',
        title: this.$t('Successful'),
        text: this.$t('password_was_copied'),
      });
    },
  },
};
</script>

<style scoped></style>
